<template>
  <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-row>
      <v-col cols="12" sm="12">
        <v-card
          class="pa-3 rounded-0 elevation-0 mt-6"
          :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'"
        >
          <v-sheet
            class="transactionTable liveTradeTable pb-3"
            :color="$vuetify.theme.dark ? '#1A2A3E' : '#F1F7FB'"
          >
            <v-data-table
              :headers="headers"
              :items="formattedInvestorAccounts"
              :items-per-page="6"
            >
              <template v-slot:item.userImage>
                <v-avatar size="31">
                  <v-img src="@/assets/avatar.png"></v-img>
                </v-avatar>
              </template>

              <template v-slot:item.name="{ item }">
                {{ item.fullName }}
              </template>

              <template v-slot:item.login="{ item }">
                {{ item.login || "-" }}
              </template>

              <template v-slot:item.accountType="{ item }">
                <span :class="item.groupClass">
                  {{ item.accountType || "-" }}
                </span>
              </template>

              <template v-slot:item.updatedAt="{ item }">
                {{ formatDate(item.updatedAt) }}
              </template>

              <template v-slot:item.balance="{ item }">
                {{ formatNumber(item.balance) }} $
              </template>

              <template v-slot:item.equity="{ item }">
                {{ formatNumber(item.equity) }}
              </template>

              <template v-slot:item.margin="{ item }">
                {{ formatNumber(item.margin) }}
              </template>

              <template v-slot:item.runningOrders="{ item }">
                {{ item.runningOrders }}
              </template>

              <template v-slot:item.status="{ item }">
                <span :class="getStatusClass(item.isActive)">
                  {{ item.isActive ? "Active" : "Inactive" }}
                </span>
              </template>

              <template v-slot:item.actions="{ item }">
                <div class="trade-dropdown">
                  <v-menu
                    rounded="0"
                    class="trade-dropdown-menu"
                    transition="slide-x-transition"
                    bottom
                    left
                  >
                    <template v-slot:activator="{ attrs, on }">
                      <v-btn
                        small
                        tile
                        elevation="0"
                        class="ma-0 text-capitalize btn-account"
                        v-bind="attrs"
                        v-on="on"
                        icon
                      >
                        <v-icon :color="$vuetify.theme.dark ? '#fff' : '#162334'">
                          mdi-dots-vertical
                        </v-icon>
                      </v-btn>
                    </template>

                    <v-card class="dropdown-menu-card" tile flat>
                      <v-list
                        flat
                        outlined
                        :color="$vuetify.theme.dark ? '#111A26' : '#F1F7FB'"
                      >
                        <v-list-item-group>
                          <v-list-item :ripple="false">
                            <span
                              @click="updateStatus(item.id)"
                              :style="{
                                fontSize: '14px',
                                color: item.isActive ? '#ffc020' : '#039de9'
                              }"
                            >
                              {{ item.isActive ? "Inactive" : "Active" }}
                            </span>
                          </v-list-item>

                          <v-list-item :ripple="false">
                            <span
                              @click="removeInvestor(item.id)"
                              :style="{
                                fontSize: '14px',
                                color:'#F80A0A',
                                marginTop: '10px',
                                marginBottom: '0px',
                              }"
                            >
                            Delete
                            </span>
                            <!-- <confirm-dialog
                              :investor-name="item.fullName"
                              @confirm="removeInvestor(item.id)"
                              DELETE
                            /> -->
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-menu>
                </div>
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { MAM__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  name: "InvestorTable",
  
  data() {
    return {
      headers: [
        { text: "User", value: "userImage", align: "start" },
        { text: "Name", value: "name" },
        { text: "Login", value: "login" },
        // { text: "Group", value: "accountType" },
        { text: "Last Update", value: "updatedAt" },
        { text: "Balance", value: "balance" },
        { text: "Equity", value: "equity" },
        { text: "Margin", value: "margin" },
        { text: "Mt5 Currency", value: "currency_name" },
        { text: "Run. Order", value: "runningOrders" },
        { text: "Status", value: "status" },
        { text: "Action", value: "actions" }
      ]
    };
  },

  computed: {
    ...mapState("mam", ["managerInvestorAccounts"]),
    
    formattedInvestorAccounts() {
      return this.managerInvestorAccounts.map(account => ({
        id: account.id,
        fullName: `${account.clientInfo.fname} ${account.clientInfo.lname}`,
        login: account.investor_account,
        // accountType: account.accountType,
        updatedAt: account.updated_at,
        balance: account.mt5AccountInfo.Balance,
        equity: account.mt5AccountInfo.Equity,
        margin: account.mt5AccountInfo.MarginFree,
        currency_name: account.mt5AccountInfo.currency_name,
        runningOrders: account.running_orders,
        isActive: account.is_active === 1
      }));
    }
  },

  methods: {
    ...mapActions("mam", [
      MAM__ACTIONS.MANAGERACCOUNTDETAILS,
      MAM__ACTIONS.MANAGERACTIVERUNNINGORDERDETAILS,
      MAM__ACTIONS.UPDATEACTIVESTATUS,
      MAM__ACTIONS.REMOVEINVESTOR
    ]),

    formatDate(mysqlDate) {
      if (!mysqlDate) return "Invalid date";
      
      const date = new Date(mysqlDate);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      const hour = date.getHours() % 12 || 12;
      const minute = date.getMinutes().toString().padStart(2, '0');
      const amPm = date.getHours() >= 12 ? 'pm' : 'am';

      return `${day}.${month}.${year} - ${hour}:${minute} ${amPm}`;
    },

    formatNumber(value) {
      return (Number(value) || 0).toFixed(2);
    },

    getStatusClass(isActive) {
      return isActive ? "status-active" : "status-inactive";
    },

    async updateStatus(id) {
      try {
        await this[MAM__ACTIONS.UPDATEACTIVESTATUS](id);
      } catch (error) {
        console.error("Error updating status:", error);
      }
      await this[MAM__ACTIONS.MANAGERACCOUNTDETAILS](this.$route.query.id);
      await this[MAM__ACTIONS.MANAGERACTIVERUNNINGORDERDETAILS](this.$route.query.id);
    },

    async removeInvestor(id) {
      try {
        await this[MAM__ACTIONS.REMOVEINVESTOR](id);
      } catch (error) {
        console.error("Error removing investor:", error);
      }
      await this[MAM__ACTIONS.MANAGERACCOUNTDETAILS](this.$route.query.id);
      await this[MAM__ACTIONS.MANAGERACTIVERUNNINGORDERDETAILS](this.$route.query.id);
    }
  },

  async mounted() {
    await this[MAM__ACTIONS.MANAGERACCOUNTDETAILS](this.$route.query.id);
  }
};
</script>

<style scoped>
.status-active {
color: #2adf52 !important;
}

.status-inactive {
  color: #ff0606 !important;
}
</style>